import $ from 'jquery';

document.addEventListener("turbo:load", function() {
  if ($("#job-status-page").length) {
    $("#job-status-result").text(i18n.t("javascript.job_status.loading"));
    var count = 0;
    var maxPolls = 70; // 3.5 minutes with 3s interval
    var width = 0;
    var elem = document.getElementById("job-status-animate-bar");
    frameAnimate(10);

    var updateInterval = setInterval(function() {
      count += 1;
      checkStatus();
    }, 3000);

    function checkStatus() {
      if (count === 1) {
        frameAnimate(50);
        $("#job-status-result").text(i18n.t("javascript.job_status.creating_documents"));
      }

      $.ajax({
        method: "GET",
        url: window.location.href + "/loading_status",
        success: function(response) {
          let status = response.status;
          let percentage = parseInt(response.complete_percentage, 10);
          let message = response.message;

          if (count > maxPolls) {
            $("#job-status-result").text(message);
            completeAndRedirect(0, response.next_step);
            clearInterval(updateInterval);
          } else if (status === "halfway_complete") {
            frameAnimate(percentage);
            $("#job-status-result").text(message);
          } else if (status === "mostly_complete") {
            frameAnimate(percentage);
            $("#job-status-result").text(message);
          } else if (status === "complete") {
            $("#job-status-result").text(message);
            completeAndRedirect(100, response.next_step);
            clearInterval(updateInterval);
          }
        },
      });
    }

    function completeAndRedirect(addWidth, nextStep) {
      frameAnimate(addWidth);
      setTimeout(() => {
        window.location = nextStep;
      }, 2000);
    }

    function frameAnimate(width) {
      if (width >= 100) {
        elem.style.width = "95%";
        elem.innerHTML = "95%";
      } else {
        elem.style.width = width + "%";
        elem.innerHTML = width + "%";
      }
    }
  }
});
